import { TextField, TextFieldProps } from 'formik-mui'
import React from 'react'
import { NumberFormatProps } from 'react-number-format'
import { Testable } from 'utils-next/types'

import { InputAdornment } from '@mui/material'

import { NumberInput } from '../../Inputs/Number'

export type NumberFieldProps = Testable &
  TextFieldProps & {
    internalInputProps?: NumberFormatProps
    adornmentText?: string
  }

export function NumberField({ internalInputProps, adornmentText, ...props }: NumberFieldProps) {
  return (
    <TextField
      {...props}
      InputProps={{
        ...props.InputProps,
        startAdornment: adornmentText && <InputAdornment position="start">{adornmentText}</InputAdornment>,
        inputComponent: NumberInput,
        inputProps: internalInputProps,
      }}
    />
  )
}
